import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData, ConvertPurchaseOrderToPurchase, ConvertPurchaseOrderVerify } from '../../../apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { Modal } from '@material-ui/core';
import { Tooltip } from '@mui/material';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import PrintIcon from '@mui/icons-material/Print';
import ReactDOM from 'react-dom';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import IconButton from '@mui/material/IconButton'; // For Material-UI's IconButton
import EditIcon from '@mui/icons-material/Edit';  // For Material-UI's EditIcon


const PurchaseOrderDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;
    const [orderQuantities, setOrderQuantities] = useState({});
    const [PurchaseOrderId, setPurchaseOrderId] = useState({});

    useEffect(() => {
        fetchData('PurchaseOrderApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.PurchaseOrder);
                    setPurchaseOrderId(response.response_data.PurchaseOrder.Id);
                    setSelectedItems(response.response_data.PurchaseOrderDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    //Is Finished
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleFinishPurchaseOrder = (PurchaseOrderId) => {
        ConvertPurchaseOrderToPurchase('PurchaseOrderApi', `${PurchaseOrderId}`, token)
            .then(() => {
                history.push("/PurchaseOrderIndex");
            })
            .catch((error) => {
                console.error('Error Converted to Purchase record:', error);
            });
    };

    //Is Verified
    const [isModalOpenverify, setIsModalOpenverify] = useState(false);
    const openModalverify = () => setIsModalOpenverify(true);
    const closeModalverify = () => setIsModalOpenverify(false);

    const handleVerifyPurchaseOrder = (PurchaseOrderId) => {
        ConvertPurchaseOrderVerify('PurchaseOrderApi', `${PurchaseOrderId}`, token)
            .then(() => {
                let purchaseorderId = PurchaseOrderId;
                handlePrint(purchaseorderId);
                history.push("/PurchaseOrderIndex");
            })
            .catch((error) => {
                console.error('Error Converted to Purchase record:', error);
            });
    };


    const handlePrint = async (purchaseorderId) => {
        // try {
        //     const response = await fetchData('PurchaseOrderApi', `/PurchaseOrderPrint/${purchaseorderId}/${branchId}`, token);
        //     const labelData = response.response_data;
        //     const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

        //     const iframe = document.createElement('iframe');
        //     iframe.style.display = 'none';
        //     document.body.appendChild(iframe);

        //     const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        //     iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

        //     ReactDOM.render(
        //         <PurchaseOrderPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
        //         iframeDocument.body
        //     );

        //     iframeDocument.write('</body></html>');
        //     iframeDocument.close();

        //     setTimeout(() => {
        //         iframe.contentWindow.print();
        //     }, 1000);

        // } catch (error) {
        //     console.error('Error printing Invoice:', error);
        // }
    };


    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

            <div className="flex justify-between items-center mb-4">
                <h6
                    className="block uppercase tracking-wide text-black flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        width: '40%',
                        marginTop: '10px',
                    }}
                >
                    Purchase Order Details

                </h6>
                <div className="w-1/5 mr-2">
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '230px' : '170px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '25px'
                        }}
                    />
                </div>
                {/* Save/Cancel Buttons */}
                <div className="mt-8">

                    {formData.IsConverted === false && formData.IsVerified === false && (
                        <Tooltip
                            title="Verify Purchase Order"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: 'darkblue',
                                        color: 'white',
                                        border: '1px solid white',
                                        fontWeight: 'bold',
                                        boxShadow: 2,
                                    },
                                },
                            }}
                        >
                            <Button
                                style={{ marginLeft: '8px', color: 'darkgreen' }}
                                onClick={openModalverify}
                                disabled={isLoading}
                            >
                                <VerifiedUserIcon style={{ color: 'darkblue', height: '22px' }} />
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Verified</b>}
                            </Button>
                        </Tooltip>
                    )}

                    {formData.IsConverted === false && formData.IsVerified === true && (
                        <Tooltip
                            title="Finish Purchase Order"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: 'darkblue',
                                        color: 'white',
                                        border: '1px solid white',
                                        fontWeight: 'bold',
                                        boxShadow: 2,
                                    },
                                },
                            }}
                        >
                            <Button
                                style={{ marginLeft: '8px', color: 'darkgreen' }}
                                onClick={openModal}
                                disabled={isLoading}
                            >
                                <DoubleArrowIcon style={{ color: 'teal', height: '22px' }} />
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>To Purchase</b>}
                            </Button>
                        </Tooltip>
                    )}

                    <Button
                        color="error"
                        component={Link}
                        to="/PurchaseOrderIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>
                </div>
            </div>


            {/* Verify Purchase Order */}
            <Modal open={isModalOpenverify} onClose={closeModalverify} style={{ marginTop: '10%' }}>
                <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: 'auto', width: '30%', textAlign: 'center' }}>
                    <h5>Verify Purchase Order   🤔!</h5>
                    <p>Are you sure , You want to Verify this Purchase Order?</p>
                    <Button
                        style={{ margin: '8px', color: 'darkgreen' }}
                        onClick={() => handleVerifyPurchaseOrder(PurchaseOrderId)}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Verify</b>}
                    </Button>
                    <Button
                        style={{ margin: '8px', color: 'brown' }}
                        onClick={closeModalverify}
                    >
                        <b>Cancel</b>
                    </Button>
                </div>
            </Modal>

            {/* Finish Purchase Order */}
            <Modal open={isModalOpen} onClose={closeModal} style={{ marginTop: '10%' }}>
                <div
                    style={{
                        padding: '20px',
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        margin: 'auto',
                        width: '30%',
                        textAlign: 'center',
                    }}
                >
                    <h5>Convert Purchase Order 🤝!</h5>
                    <p>Are you sure you want to convert this Purchase Order?</p>
                    <Button
                        style={{ margin: '8px', color: 'darkgreen' }}
                        component={Link}
                        to={`/PurchaseCreate/${id}`}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Finish</b>}
                    </Button>
                    <Button style={{ margin: '8px', color: 'brown' }} onClick={closeModal}>
                        <b>Cancel</b>
                    </Button>
                </div>
            </Modal>


            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ marginTop: '-2%' }}>

                {/* Main content taking 3/5 of the width */}
                <div className="w-full pr-4">
                    {/* Form fields and Purchase Order Table */}
                    <div className="w-full mb-2 flex">
                        <div className="w-3/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Supplier Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.SupplierName}
                                type="text"
                                placeholder="CustomerName"
                                name='CustomerName'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice Type
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.InvoiceTypeName}
                                type="text"
                                placeholder="Invoice Type Name"
                                name='InvoiceTypeName'
                                readOnly
                                style={{ height: '35px' }}
                            />

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                PO Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.PurchaseOrderDate)}
                                type="date"
                                name='PurchaseOrderDate'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                PO No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.PurchaseOrderNo || ''}/${formData.FinYear || ''}`}
                                type="text"
                                placeholder="PO Number"
                                name='PurchaseOrderNo'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-2 flex">

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Amount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.Amount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="Amount"
                                    placeholder="Amount"
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Amount.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.DiscountAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.DiscountAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="DiscountAmount"
                                    placeholder="Discount Amount"
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Disc.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CGSTAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.CGSTAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="CGSTAmount"
                                    placeholder="CGST Amount"
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    CGST.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.SGSTAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.SGSTAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="SGSTAmount"
                                    placeholder="SGST Amount"
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    SGST.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.IGSTAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.IGSTAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="IGSTAmount"
                                    readOnly
                                    placeholder="SGST Amount"
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    IGST.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.FreightAmount}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        //color: formData.FreightAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name='FreightAmount'
                                    readOnly

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Freight.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.RoundOff}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        //color: formData.RoundOff > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name='RoundOff'
                                    readOnly

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    RoundOff.
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TotalAmount}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        //color: formData.RoundOff > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name='TotalAmount'
                                    readOnly

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    Total.
                                </span>
                            </div>
                        </div>

                    </div>

                    {/* Remarks */}


                    {/* Instruction1 */}
                    <div className="w-full mb-2 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                Remarks
                                <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                rows={1}
                                readOnly

                            />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                Instruction 1
                                <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Instruction"
                                name="Instruction1"
                                value={formData.Instruction1}
                                rows={1}
                                readOnly
                            />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                Instruction 2
                                <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Instruction"
                                name="Instruction2"
                                value={formData.Instruction2}
                                rows={1}
                                readOnly
                            />
                        </div>
                    </div>


                    {/* Purchase Order Table */}
                    <div className="w-full mb-2">
                        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>ITEM NAME</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>ORDER QTY</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>RATE</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>DIS %</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>DIS ₹</th>
                                    <th className="py-2 px-4 border-b" style={{ fontSize: '13px', color: '#A10035' }}>AMOUNT</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.map((item, index) => {
                                    const details = orderDetails[item.Id] || {};
                                    const defaultOrderQty = item.ApprovedQuantity || 0;
                                    const orderQty = orderQuantities[item.Id] || defaultOrderQty;


                                    return (
                                        // <tr key={index} className="border-b">
                                        <tr key={index} className="border-b"
                                            style={{
                                                backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                borderBottom: '1px solid #E0E0E0',
                                                transition: 'transform 0.2s ease-in-out',
                                                cursor: 'pointer',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                        >

                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '500px' }}>{item.ItemName}</td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    type="number"
                                                    value={item.OrderedQuantity || item.OrderedQuantity}
                                                    className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                    style={{
                                                        fontSize: '13px',
                                                        fontWeight: 'bold',
                                                        backgroundColor: (item.OrderedQuantity || 0) > 0 ? '#FFEFEF' : '#D3F1DF',
                                                        textAlign: 'right'
                                                    }}
                                                    min="0"
                                                    aria-label={`Order quantity for item ${item.Id}`}
                                                    name="OrderedQuantity"
                                                />
                                            </td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.Rate || 0}
                                                    className="w-full px-2 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    type="number"
                                                    name="Rate"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.DiscountPercentage || 0}
                                                    className="w-full px-2 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    type="number"
                                                    name="DiscountPercentage"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.DiscountAmount || 0}
                                                    readOnly
                                                    className="w-full px-2 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.TotalAmount || 0}
                                                    readOnly
                                                    className="w-full px-2 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D3F1DF', textAlign: 'right' }}
                                                />
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseOrderDetails;
